module.exports = __webpack_public_path__ + "media/images/chek_logo-a0abd50468be1cb7c7c8711cc6cd87d1.png";